import { type FC } from "react";
import { Link } from "@root/shared/components/Link";
import { Icon } from "@root/shared/components/Icon";
import { fontSize } from "@root/shared/styles/sprinkles.css";
import { RoundCassette } from "../RoundCassette";
import * as styles from "./styles.css";

type Props = {
  path: string;
  className?: string;
};

export const AppPromotion: FC<Props> = ({ path, className }) => (
  <RoundCassette hasBorder className={`${styles.outer} ${className ?? ""}`}>
    <div className={styles.iconAndText}>
      <img src="/images/user_frontend/sp/app/app_banner_icon.png" alt="アプリのアイコン" />
      <p>
        求人検索は
        <span className={styles.boldText}>アプリが便利！</span>
      </p>
    </div>
    <Link
      href={path}
      theme="primary"
      className={styles.button}
      leftIcon={<Icon name="download" fontSize={fontSize["fs-16"]} />}
      rightIcon={<Icon name="arrow-light-right" fontSize={fontSize["fs-16"]} />}
      data-ga-action="assess_result__webtoapp_banner"
    >
      アプリで求人を検索する
    </Link>
  </RoundCassette>
);
